export default __webpack_public_path__ + "static/media/resultpagemockup.e42719e3.png";